import KmxFireFilled from '@kmx/mui-icons/KmxFireFilled';
import Chip, { type ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

import type { CarStatus } from '../../types/CarStatus';

type BadgeProps = { carStatus: CarStatus };

const STATUSES: Array<{ status: keyof CarStatus; label: string }> = [
  { status: 'isSold', label: 'Sold' },
  { status: 'isReserved', label: 'Reserved' },
  { status: 'isComingSoon', label: 'Coming soon' },
  { status: 'isPopular', label: 'Popular' },
  { status: 'isNewMatch', label: 'New for you' },
  { status: 'hasPriceDrop', label: 'Price drop' },
  { status: 'isShipping', label: 'Shipping' },
];

const StyledChip = styled(Chip)<ChipProps>(() => ({
  left: '0.5rem',
  position: 'absolute',
  top: '0.5rem',
  zIndex: 2,
}));

const DefaultChip = styled(StyledChip)(({ theme }) => ({
  // This really should be handled by the theme itself...
  background: theme.palette.background.default,
}));

const PopularIcon = styled(KmxFireFilled)(({ theme }) => ({
  color: `${theme.palette.warning.light} !important`,
}));

export default function Badge({ carStatus }: BadgeProps) {
  const badgeStatus = STATUSES.find(({ status }) =>
    Boolean(carStatus?.[status]),
  );

  if (!badgeStatus) {
    return null;
  }

  if (badgeStatus.status === 'isPopular') {
    return (
      <DefaultChip
        data-testid="badge"
        icon={<PopularIcon />}
        label={badgeStatus.label}
        variant="outlined"
      />
    );
  }

  if (badgeStatus.status === 'hasPriceDrop') {
    return (
      <StyledChip
        color="success"
        data-testid="badge"
        label={badgeStatus.label}
      />
    );
  }

  return (
    <DefaultChip
      data-testid="badge"
      label={badgeStatus.label}
      variant="outlined"
    />
  );
}
